module.exports = __webpack_public_path__ + "gef.51bedb0a91d9a1dcd6c1fb680bcaec84.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footer/gef.jpg
// module id = 467
// module chunks = 0